import { FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import React, { FC } from 'react';
import { QuestionView } from '@views';
import { useNavigationEligibility } from '@components/SurveyDrawer/NavigationEligibilityContextProvider';

interface MutuallyExclusiveResponseProps {
  currentQuestion: QuestionView;
}

export const MutuallyExclusiveResponse: FC<MutuallyExclusiveResponseProps> = ({ currentQuestion }) => {
  const [selected] = React.useState<number>(-1);
  const { triggerEligibility } = useNavigationEligibility();
  const setQuestionResponse = (currentQuestion: QuestionView, optIdx: number, e: any) => {
    currentQuestion.responses[optIdx].selected = Boolean(e.target.checked);
    if (e.target.checked) {
      currentQuestion.responses[optIdx].textResponse = String(e.target.value);
    }
  };
  const handleMutuallyExclusiveResponse = (e: any) => {
    const optIdx = currentQuestion.responses.findIndex((x) => x.id === Number(e.target.value));
    // unselect all values
    currentQuestion.responses[optIdx].textResponse = '';
    currentQuestion.responses.forEach((x) => {
      x.selected = false;
      x.textResponse = '';
    });

    // set the selected value as the only one selected
    setQuestionResponse(currentQuestion, optIdx, e);
    triggerEligibility();
  };
  const currentStepResponses = currentQuestion.responses;
  return (
    <>
      {currentStepResponses.some((opt) => opt.responseType === 'MutuallyExclusive') && (
        <RadioGroup sx={{ gap: 2, padding: 2 }} onChange={handleMutuallyExclusiveResponse} value={selected}>
          {currentQuestion.responses.map((opt) => {
            const key = `option-${opt.id}`;
            if (opt.responseType === 'MutuallyExclusive') {
              return (
                <Grid
                  size={{ xs: 12 }}
                  key={key}
                  flexWrap={'wrap'}
                  alignContent="center"
                  justifyContent={'flex-start'}
                  flexDirection={'row'}
                  display={'flex'}
                >
                  <FormControlLabel value={opt.id} control={<Radio checked={opt.selected} />} label={opt.text} />
                </Grid>
              );
            }
            return null;
          })}
        </RadioGroup>
      )}
    </>
  );
};
